module.exports = __webpack_public_path__ + "static/media/gicon-2.e1406d37.png";